import enable from './enable';
import disable from './disable';

export default {
  enable,
  disable,
};
